//const ekIntegration = require('../../services/mvc-api/services/Ruibei.Api.WebControllers.EKIntegration.Service').EKIntegrationService;20191111
export default {
    name: 'Root',
    data() {

        return {
            isykUrl: '',
            isApply: null,
        };
    },
    methods: {
        // 用于初始化一些数据
        init() { },
        // 用于更新一些数据
        async update() {
            // 判断是否开通膳食
          //  this.isApply = await ekIntegration.GetIsApplyEK({ Value: this.$UserInfo.HospitalId });20191111
        },
      
        dropdownClick(name) {
            if (this[name]) {
                this[name]();
            }
        },
        signOut() {
            localStorage.clear();
            sessionStorage.clear();
            window.location.href = '/Login';
        },
        // 获取膳食链接
        async onOpenChange(e) {
            if (e == 'Diet') {
                // const res = await ekIntegration.GetEKUrlAndLogin({
                //     //hospitalId: this.$UserInfo.HospitalId,
                //     roleId: this.$UserInfo.RoleDefaultId,
                // });20191111
                if (res.Status) this.isykUrl = res.Url;
            }
        },
        // 同步儿童数据
        async updateChil() {
            const loading = this.$loading({
                lock: true,
                text: '请稍后',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            try {
                // const res = await ekIntegration.InitClassAndStudent({ HospitalId: this.$UserInfo.HospitalId });20191111
                // loading.close();
                // if (res.Code == 2000) {
                //     this.$success('操作成功');
                // } else {
                //     this.$error(res.Msg);
                // }
            } catch (error) {
                loading.close();
                this.$error('接口错误！');
            }

        },
    },
    // 计算属性
    computed: {
        // 判断用户角色 显示问候语
        identity() {
            let identity = '';4
            identity = '管理员';
            return identity;
        }
    },
    // 包含 Vue 实例可用过滤器的哈希表。
    filters: {
    },
    // 在实例创建完成后被立即调用
    created() { },
    // 在挂载开始之前被调用：相关的 render 函数首次被调用。
    beforeMount() {
        this.update();
    },
    // el 被新创建的 vm.el 替换，并挂载到实例上去之后调用该钩子。
    mounted() {
        this.$nextTick(() => { });
    },
    // 数据更新时调用，发生在虚拟 DOM 打补丁之前。
    beforeUpdate() { },
    // keep-alive 组件激活时调用。
    activated() {
    },
    // keep-alive 组件停用时调用。  
    deactivated() { },
    // 实例销毁之前调用。在这一步，实例仍然完全可用。
    beforeDestroy() { },
    //Vue 实例销毁后调用。
    destroyed() { },
    // 当捕获一个来自子孙组件的错误时被调用。此
    errorCaptured() { },
    // 包含 Vue 实例可用指令的哈希表。
    directives: {},
    // 一个对象，键是需要观察的表达式，值是对应回调函数。
    watch: {

    },
    // 组件列表
    components: {},
};